
import { useState } from "react";
import { useSelector } from "react-redux";

import Box from "@mui/material/Box";
import { Paper, Stack } from "@mui/material";

export default function ChallengeDataMonitoring() {

  const [show, setShow] = useState(false)
  const challenges = useSelector( store => store.challenge.challenges) //fetchChallengeData
  const completed_challenges = useSelector( store => store.challenge.completed_challenges) //fetchCompletedChallengeData
  const challenge_task_percentage_amounts = useSelector( store => store.challenge.challenge_task_percentage_amounts) //fetchChallengePercentages

  function handleClick(){
    setShow(!show)
  }

  return (
    <Paper
      sx={{
        padding: 2,
        mt: 1
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>

        <Stack>
        <div>
          <button onClick={handleClick}>
            Show/Hide Challenge Fetch Status
          </button>
        </div>

        { show == true &&
          <div>
            <h1>
              Challenge Data Monitoring
            </h1>
            { challenges?.length >0 ? <p>fetchChallengeData ✅</p> : <p>fetchChallengeData ❌</p>}
            { completed_challenges?.length > 0  ? <p>fetchCompletedChallengeData ✅</p> : <p>fetchCompletedChallengeData ❌</p>}
            { challenge_task_percentage_amounts?.length > 0  ? <p>fetchChallengePercentages ✅</p> : <p>fetchChallengePercentages ❌</p>}
          </div>
        }
        </Stack>

      </Box>
    </Paper>
  );
}
